import React from 'react'
import { NavPages } from '../components/NavPages'

const Thanks = () => {

  return (
    <>
      <NavPages />
      <div className="container tc">
        <div className="row">
          <div className="col-lg-9 ma">
            <div className="s-100"></div>
            <h3 className='title c-white'>Thank you! We will get back to you ASAP.</h3>
            <div className="s-40"></div>
            <p className='c-white'>Your message has been successfully sent. We appreciate you reaching out to us and will respond to your inquiry as soon as possible.</p>
            <p className='c-white'>If you have any urgent questions, please don't hesitate to contact us directly.</p>
            <div className="s-100"></div>
            <div className="tc"><a href='/' className='button'>Return Home</a></div>
            <div className="s-100"></div>
          </div>
        </div>
      </div>
      <div className='bg-lite py-3'>
        <div className="container tc">
          <div className="s-20"></div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <a href='/' className='c-medium fw-400'>© 2026 - CrypCons. All rights reserved.</a>
            <span className='c-medium'>|</span>
            <a href='/cookie-policy' className='c-medium fw-400'>Cookie Policy</a>
            <span className='c-medium'>|</span>
            <a href='/privacy-policy' className='c-medium fw-400'>Privacy Policy</a>
          </div>
          <div className="s-20"></div>
        </div>
      </div>
    </>
  )
}

export { Thanks }
